import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { AuthenticationProvider } from "@skanska/vsa-client-auth";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { apiConfig } from "./config/AppConfig.ts";
import { msalConfig } from "./config/MsalConfig.ts";
import "./style/root.scss";

const skanskaTheme = {
  ...webLightTheme,
  fontFamilyBase: '"Shape Sans", sans-serif',
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <FluentProvider theme={skanskaTheme}>
      <AuthenticationProvider msalConfig={msalConfig} appConfig={apiConfig}>
        <App />
      </AuthenticationProvider>
    </FluentProvider>
  </StrictMode>
);
